import React from "react";

const LoaderSimulationsTable = () => {
    return (
        <div className="loader_simulations_cont">
            <div className="loader_simulations_cont_main">

                <div className="loader_simulations_cont_header"></div>
                <div className="loader_simulations_cont_body">
                    <div className="loader_simulations_cont_body_row"></div>
                    <div className="loader_simulations_cont_body_row"></div>
                    <div className="loader_simulations_cont_body_row"></div>
                    <div className="loader_simulations_cont_body_row"></div>
                    <div className="loader_simulations_cont_body_row"></div>
                </div>
            </div>
            <div className="loader_simulations_cont_scroll">
                <div className="loader_simulations_cont_scroll_inner"></div>
            </div>
        </div>
    )
}

export default LoaderSimulationsTable